import i18next from 'i18next';
import { html } from 'lit-html';

const TemplateEmbedIndicatorsErniSNP = ({ variant = '44' } = {}) => {
  const template44 = html` <div
    class="col-sm-12 col-xs-12 mypErniWidgetView"
    id="mypErniWidgetView"
  >
    <div id="spinner44" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div class="row">
      <div id="mypGraphic44" class="chari-chart">
        <div
          id="mypNoDataRect44"
          class="esios-home__no-data-container_cuadrado hidden"
        >
          ${i18next.t('no-data-available')}
        </div>
      </div>
      <ul class="esios-listEnergyItems__list">
        <div class="row"></div>
      </ul>
    </div>

    <div class="col-xs-24 col-sm-24 mt-5"></div>
  </div>`;

  const template43 = html` <div class="mp-tree-graphs row mb-5">
    <div class="col-sm-12 col-xs-6 mypErniWidgetView" id="mypErniWidgetView">
      <div id="spinner43" class="spinner-container">
        <div class="overlay"></div>
        <div class="spinner"></div>
      </div>
      <div id="widget43">
        <div id="mypGraphic43" class="chari-chart aspect2 myp-aspect">
          <div
            id="mypNoDataRect43"
            class="esios-home__no-data-container2_cuadrado hidden"
          >
            ${i18next.t('no-data-available')}
          </div>
        </div>
      </div>
    </div>
  </div>`;

  return variant === '43' ? template43 : template44;
};

export default TemplateEmbedIndicatorsErniSNP;
